import React, { useState } from "react";
import { FamilyResponse, FamilyRequest, PatientInputForm, CaretakerInputForm } from "../types/FamilyTypes";
import { addFamily } from "../services/familyService";
import "../styles/form.css";
import "../styles/family.css";

interface AddFamilyFormProps {
  loadFamilies: () => void;
}

const AddFamilyForm: React.FC<AddFamilyFormProps> = ({ loadFamilies }) => {
    const [newFamily, setNewFamily] = useState<FamilyRequest>({
        familyName: "",
        members: [
            {
                isPatient: false,
                firstName: "",
                lastName: "",
                phoneNumber: "",
                birthDate: "2025-04-01"
            },
            {
                isPatient: false,
                firstName: "",
                lastName: "",
                phoneNumber: "",
                birthDate: "2025-04-01"
            }            
        ]
    })

    const [newPatient, setPatient] = useState<PatientInputForm>({
      firstName: "",
      lastName: "",
      phoneNumber: "",
      birthDate: "2025-04-01"
    });

    const [newCaretaker, setCaretaker] = useState<CaretakerInputForm>({
      phoneNumber: ""
    });


    const handleMemberChange = (memberType: string, e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      if (memberType === "patient") {
        setPatient({...newPatient, [e.target.name]: e.target.value})
      }
      else if (memberType === "caretaker") {
        setCaretaker({...newCaretaker, [e.target.name]: e.target.value})
      }
    };


    const handleFamlySubmit = async (e: React.FormEvent) => {
      e.preventDefault();

      if (!newPatient.firstName || !newPatient.lastName || !newPatient.phoneNumber || !newCaretaker.phoneNumber) {
        alert("Please fill in all required fields.");
        return;
      }
  
      const updatedFamily: FamilyRequest = {
        familyName: `${newPatient.firstName} ${newPatient.lastName}`,
        members: [
          {
            isPatient: true,
            firstName: newPatient.firstName,
            lastName: newPatient.lastName,
            phoneNumber: newPatient.phoneNumber,
            birthDate: "2025-04-01"
          },
          {
            isPatient: false,
            firstName: `(Caretaker)${newPatient.firstName}`,
            lastName: `(Caretaker)${newPatient.lastName}`,
            phoneNumber: newCaretaker.phoneNumber,
            birthDate: "2025-04-01"
          }
        ]
      };
  
      const response = await addFamily(updatedFamily);
  
      if (response) {
        alert("Family added successfully!");
        setPatient({
          firstName: "",
          lastName: "",
          phoneNumber: "",
          birthDate: "2025-04-01"
        })

        setCaretaker({
          phoneNumber: ""
        })

        loadFamilies(); // Refresh message list
      } else {
        alert("Failed to add family.");
      }
  };

  return (
      <div className="form-container">
        <h2>Register New Family</h2>
        <form onSubmit={handleFamlySubmit}>
          <div>
              <h3>Patient</h3>
              <div className="input-group">
                <div className="input-row">
                    <input type="text" name="firstName" placeholder="First Name" value={newPatient.firstName} onChange={(e) => handleMemberChange("patient", e)} required />
                    <input type="text" name="lastName" placeholder="Last Name" value={newPatient.lastName} onChange={(e) => handleMemberChange("patient", e)} required />
                    <input type="text" name="phoneNumber" placeholder="Phone Number" value={newPatient.phoneNumber} onChange={(e) => handleMemberChange("patient", e)} required />
                </div>
              </div>
              <h3>Caretaker</h3>
              <div className="input-group">
                  <div className="input-row caretaker-phone-number-field">
                    <input type="text" name="phoneNumber" placeholder="Phone Number" value={newCaretaker.phoneNumber} onChange={(e) => handleMemberChange("caretaker", e)} required />
                  </div>
              </div>
          </div>
  
          <button className="submit-button" type="submit">Submit</button>
        </form>
      </div>
    );
}

export default AddFamilyForm;